<template>
  <div id="app" ref="app" >
    <MainView />
    <Xiaoqu />
    <O2vr />
    <Shuiyin/>
  </div>
</template>

<script>
import MainView from "./components/MainView.vue";
import Xiaoqu from "./components/xiaoqu.vue";
import O2vr from "../common/components/o2vr.vue";
import Shuiyin from '../common/components/shuiyin.vue';
export default {
  name: "App",
  data() {
    return {};
  },
  components: { MainView, O2vr, Xiaoqu, Shuiyin },
  created() {},
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#layout-container,
#mainrow,
#main-container {
  margin: auto, 0;
  height: 100%;
  width: 100%;
}
</style>